<template lang="pug">
  #AdminSuperResellers
    ResellersTable
</template>

<script>
import ResellersTable from "@@/Resellers/ResellersTable";

export default {
  name: "AdminSuperReseller",

  components: { ResellersTable },

  data() {
    return {};
  }
};
</script>
